<template>
<div class="vliveDataStatistics">
    <vliveHeader :item="item" class="bgc box-shadow"></vliveHeader>
    <div class="boxs">
        <div class="box box-shadow" v-for="(item,index) in keyData" :key="index">
            <div class="summary" :class="numCls(item.type)">{{item.title}}</div>
            <div class="content">
                <div class="num" :class="numCls(item.type)">{{item.total}}</div>
                <i class="icon overflow" :class="type(item.type)"></i>
            </div>
        </div>
    </div>
    <div class="data-echarts">
        <div><el-button type="primary" @click="handleExport">导出数据</el-button></div>
        <div class="trend">
            <div class="trendTitle">
                <div class="classes blod">观看时间段分析</div>
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="今日" name="first"></el-tab-pane>
                    <el-tab-pane label="昨日" name="second"></el-tab-pane>
                    <el-tab-pane label="近7日" name="third"></el-tab-pane>
                    <el-tab-pane label="近30日" name="fourth"></el-tab-pane>
                    <el-tab-pane>
                    <span slot="label">
                        <div class="block">
                            <el-date-picker class="dateInput" v-model="param.date" type="daterange" align="right" unlink-panels
                                            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
                            </el-date-picker>
                          </div>
                    </span>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <lineReport :lineDatas="lineDatas" class="lineDatas"  :lineParam="param.shadowParam"></lineReport>
        </div>
        <div class="trend">
            <div class="trendTitle">
                <div class="classes blod">用户画像</div>
            </div>
            <div class="pie">
                <pieReport :data="sexTotal"></pieReport>
                <pieReport :data="userTotal"></pieReport>
            </div>
        </div>
        <div class="trend">
            <div class="trendTitle">
                <div class="classes blod">观看区域分布图</div>
            </div>
            <div class="geography">
                <geographyReport></geographyReport>
            </div>
        </div>
        <div class="trend">
            <div class="trendTitle">
                <div class="classes blod">观看终端</div>
            </div>
            <div class="pie">
                <pieReport :data="sTotal"></pieReport>
                <stripReport :stripDatas="stripDatas"></stripReport>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import VliveHeader from 'views/cms/vlive/components/vliveHeader'
import LineReport from 'base/echarts/lineReport'
import PieReport from 'base/echarts/pieReport'
import GeographyReport from 'base/echarts/geographyReport'
import StripReport from 'base/echarts/stripReport'
export default {
    name: 'vliveDataStatistics',
    data() {
        return {
            activeName: 'first',
            item: {
                id: 1,
                name: '资鲸',
                title: '深圳职人圈 | 粤港澳斜杆大咖教你实现创业梦',
                date: '2019-05-18 14:00',
                url: 'https://f11.baidu.com/it/u=3377178523,113365104&fm=72',
                wxQrCode: 'http://i2.sinaimg.cn/dy/c/2014-07-18/1405623657_VbFlfN.jpg',
                xcxQrCode: 'http://i2.sinaimg.cn/dy/c/2014-07-18/1405623657_VbFlfN.jpg',
                switch: true
            },
            param: {
                shadowParam: 30,
                pieParam: 0,
                stripParam: 0,
                date: ''
            },
            pickerOptions: {
                shortcuts: [{
                    text: '近7日',
                    onClick(picker) {
                        const end = new Date()
                        const start = new Date()
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                        picker.$emit('pick', [start, end])
                    }
                }, {
                    text: '近7日',
                    onClick(picker) {
                        const end = new Date()
                        const start = new Date()
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                        picker.$emit('pick', [start, end])
                    }
                }]
            },
            keyData: [
                {title: '付费用户', total: 0, type: 0},
                {title: '今日付款用户', total: 0, type: 0},
                {title: '今日新增收入', total: 0, type: 1},
                {title: '可提现金额', total: 0, type: 2},
                {title: '账户余额', total: 0, type: 3}
            ],
            lineDatas: {
                id: 'index',
                subText: '浏览趋势图',
                data: [
                    {title: '访问人数', color: '#1989FA', list: [2, 10, 6, 20, 15, 35, 25]}
                ]
            },
            stripDatas: {title: '', listX: ['android', 'ios', 'win'], listY: [10, 20, 30], subText: ''},
            sTotal: {id: 'sTotal', title: '男女比例', color: ['#2FC25B', '#1989FA'], list: [{value: 20, name: '移动端'}, {value: 30, name: 'PC端'}], total: 0, subText: ''},
            sexTotal: {id: 'sexTotal', title: '男女比例', color: ['#2FC25B', '#1989FA'], list: [{value: 20, name: '男'}, {value: 30, name: '女'}], total: 0, subText: ''},
            userTotal: {id: 'userTotal', title: '男女比例', color: ['#2FC25B', '#1989FA'], list: [{value: 20, name: '男'}, {value: 30, name: '女'}], total: 0, subText: ''}
        }
    },
    mounted() {
    },
    methods: {
        handleClick() {

        },
        handleExport() {

        }
    },
    filters: {},
    watch: {
    },
    computed: {
        type() {
            return function(value) {
                switch (value) {
                case 0: return 'icon_users'
                case 1: return 'icon_browse'
                case 2: return 'icon_time'
                case 3: return 'icon_money'
                default:
                    return value
                }
            }
        },
        numCls() {
            return function(value) {
                switch (value) {
                case 0: return 'tc-blue'
                case 1: return 'tc-blue'
                case 2: return 'tc-green'
                case 3: return 'tc-orange'
                default:
                    return value
                }
            }
        }
    },
    components: {
        VliveHeader,
        LineReport,
        GeographyReport,
        StripReport,
        PieReport
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.vliveDataStatistics {
    .boxs{
        @include flexBox(flex-start);
        margin-top: 30px;
        .box{
            width: 270px;
            height: 120px;
            background: $bgcolor-white;
            padding: 30px;
            box-sizing: border-box;
            .summary{
                font-size: $font-14;
                margin-bottom: 10px;
            }
            .content{
                @include flexBox(space-between);
                .num{
                    font-size: $font-30;
                }
                .icon{
                    display: inline-block;
                    width: 34px;
                    height: 34px;
                }
            }
        }
        .box~.box{
            margin-left: 10px;
        }
    }
    .data-echarts{
        background: $bgcolor-white;
        margin-top: 30px;
        padding: 30px;
        .trend{
            margin-top: 30px;
            .trendTitle{
                @include flexBox(space-between);
            }
            .pie{
                @include flexBox(space-between);
                .pieReport,.stripReport{
                    width: 50%;
                    height: 300px;
                }
            }
        }
    }
    .el-tabs__nav-wrap::after,.el-tabs__active-bar{
        height: 0;
    }
    .el-date-editor .el-range__icon,.el-date-editor .el-range-separator{
        line-height: 26px;
    }
}
</style>
